module.exports = __webpack_public_path__ + "img/luggage-stacked.ac42850e.png";